import { Size } from "../../MyHelpers";

import { Spine } from "pixi-spine";
import * as PIXI from 'pixi.js';
import { SlotFeature } from "../SlotFeature";
import { SlotSymbol } from "../SlotSymbol";
import { RewardColor } from "./RewardOptionFactory";
import { ScatterRandomAward, ScatterRandomAwardCreateParams } from "./ScatterRandomAward";
import { ScatterRandomAwardConfiguration } from "../../api";


export class ScatterRandomAwardPIXI extends ScatterRandomAward implements SlotFeature {
    public constructor(params: ScatterRandomAwardCreateParams, config: Record<string, ScatterRandomAwardConfiguration>, color: RewardColor) {
        super(params, config, color);
    };

    // TODO use symbol name vs symbol index;
    public DrawPIXI(reelIndex: number, reelPosition: number, rowIndex: number, symbol: SlotSymbol, canvasPIXI?: PIXI.AnimatedSprite, symbolsSize?: Size , awardShow? : boolean) {

        if (this.requiredSymbolsIndex.includes(symbol.Index)) {
            //// Log.Debug(this.logGroup, `Drawing to symbol ${symbol.id} index ${symbol.index}`);
            let m = this.reelToRewardMap[reelIndex].get(reelPosition);
            let rewardOptionIndex: number = m.rewardOptionIndex;
            let reward = this.rewardOption[rewardOptionIndex];
            //// Log.Debug("SRADEBUG", `Drawing rewardOptionIndex on reelIndex ${reelIndex} rowIndex ${rowIndex} reelPosition ${reelPosition}, rewardOptionIndex ${rewardOptionIndex} name ${reward.Name()} draw ${reward.TextToDraw()}`);
            //console.log("SRADEBUG", reward);
            if(awardShow == true ) this.rewardOption[rewardOptionIndex].DrawToPIXI(canvasPIXI , symbolsSize);
        }
        else {
            //hide data when dosent need it
            canvasPIXI.parent.children.forEach((elementChild)=>{
                if(elementChild.name != 'symbol'){
                    elementChild.visible = false
                }
            })
        }

    }

    // TODO use symbol name vs symbol index;
    public DrawSpine(reelIndex: number, reelPosition: number, rowIndex: number, symbol: SlotSymbol, canvasPIXI?: PIXI.AnimatedSprite, symbolsSize?: Size, awardShow: boolean = true) {

        if (this.requiredSymbolsIndex.includes(symbol.Index)) { 
            //// Log.Debug(this.logGroup, `Drawing to symbol ${symbol.id} index ${symbol.index}`);
            let m = this.reelToRewardMap[reelIndex].get(reelPosition);
            let rewardOptionIndex: number = m.rewardOptionIndex;
            let reward = this.rewardOption[rewardOptionIndex];
            //// Log.Debug("SRADEBUG", `Drawing rewardOptionIndex on reelIndex ${reelIndex} rowIndex ${rowIndex} reelPosition ${reelPosition}, rewardOptionIndex ${rewardOptionIndex} name ${reward.Name()} draw ${reward.TextToDraw()}`);
            //console.log("SRADEBUG", reward);                        
            this.rewardOption[rewardOptionIndex].DrawToSpine(canvasPIXI.parent.children.find(c => c.name.includes("Symbol_")) as Spine, symbolsSize, null, null, awardShow);
            //hide data when dosent need it
            canvasPIXI.parent.children.forEach((elementChild) => {
                if (elementChild instanceof Spine) {
                    elementChild.visible = true
                }else {
                    elementChild.visible = false;
                }
            })
        }
    }
}
